import styled from "styled-components";
import { Virtuoso } from "react-virtuoso";
import scrollbar from "../../../helpers/scrollbar";
const StyledVariable = /*#__PURE__*/styled(Virtuoso).withConfig({
  displayName: "StyledVariable",
  componentId: "sc-k7e8ed-0"
})(["", " > *{position:relative;}"], scrollbar);
export default StyledVariable;
//# sourceMappingURL=Variable.js.map